export const setArticlesToLocalStorage = (articles) => {
  localStorage.setItem("articles", JSON.stringify(articles));
};
